module.exports = __webpack_public_path__ + "img/p1-m.985c284b.jpg";